module.exports = {
	"API_URL": "https://api.konsultacjejst.pl",
	"AUTH_STATE_ITEM_NAME": "konsultacje_forms_auth_state",
	"BUDGET_AUTH_STATE_ITEM_NAME": "konsultacje_budget_forms_auth_state",
	"GOOGLE_MAPS_API_KEY": "AIzaSyAUDGJ77tLHxjpToVwHQOcz1hQTxgzDi4c"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/config.prod.json
// module id = 1422
// module chunks = 0